export function appendMenu(element) {

    const body = document.querySelector('body');
    if (window.innerWidth <= 768) {
        body.append(element);
    }
}
